import { useState } from 'react';

export default function usePostAuthed(url, urlIdentifier = null) {
    console.log(`${urlIdentifier === 'loan' ? process.env.REACT_APP_LOAN_API_URL : process.env.REACT_APP_API_URL}/${url}`)
    const [error, setError] = useState();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const call = async (data) => {
        setLoading(true);
        try {
            const response = await fetch(`${urlIdentifier === 'loan' ? process.env.REACT_APP_LOAN_API_URL : process.env.REACT_APP_API_URL}/${url}`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${urlIdentifier === 'loan'
                        ? JSON.parse(localStorage.getItem('loanAuth'))
                            ? JSON.parse(localStorage.getItem('loanAuth')).token
                            : JSON.parse(localStorage.getItem('bankAdmin')).data.token
                        : JSON.parse(localStorage.getItem('authUser')).data?.token}`
                },
            });
            const result = await response.json();
            if (response.ok) {
                setData(result);
            } else {
                setError(result);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return [call, data, error, loading];
}